/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from "react";
import {
  DataGrid,
  GridColDef,
  GridRenderCellParams,
  GridClasses,
} from "@mui/x-data-grid";
import { Box } from "@mui/material";
import DisplayAmount from "../../shared/DisplayAmount";
import { Button } from "@chakra-ui/react";
import { FaPlus } from "react-icons/fa";
import { Tooltip, IconButton } from "@mui/material";
import { AiOutlineFileSearch } from "react-icons/ai";
import { AiOutlineEdit } from "react-icons/ai";
import AgentAssignFeeGroupModal from "./AgentAssignFeeGroupModal";
import AgentFeeGroupDetails from "./AgentFeeGroupDetails";

type RowData = {
  name: string;
  asset: string;
  method_name: string;
};

const AgentFeesTab: React.FC<{
  detail: any;
  setSwalProps: any;
  triggerReload: any;
  isFetchAssignedFeeGroups: boolean;
}> = ({ detail, setSwalProps, triggerReload, isFetchAssignedFeeGroups }) => {
  const [isOpenAssignFeeGroupModal, setIsOpenAssignFeeGroupModal] =
    useState<boolean>(false);
  const [isOpenFeeDetailsModal, setIsOpenFeeDetailsModal] =
    useState<boolean>(false);
  const [feeToViewDetails, setFeeToViewDetails] = useState<any>(null);

  const columns: GridColDef[] = [
    {
      field: "name",
      headerName: "Name",
      sortable: false,
      flex: 1,
      renderCell: (params: GridRenderCellParams<RowData, any, string>) =>
        params.row.name,
    },
    {
      field: "asset",
      headerName: "Asset",
      sortable: false,
      flex: 1,
      renderCell: (params: GridRenderCellParams<RowData, any, string>) =>
        params.row.asset,
    },
    {
      field: "method_name",
      headerName: "Method",
      sortable: false,
      flex: 1,
      renderCell: (params: GridRenderCellParams<RowData, any, string>) =>
        params.row.method_name,
    },
    {
      field: "actions",
      headerName: "",
      sortable: false,
      flex: 1,
      minWidth: 140,
      headerAlign: "right",
      align: "right",
      renderCell: (params) => {
        return (
          <>
            {/* <Tooltip title="Update" arrow placement="top">
              <IconButton
                id={"button-update-" + params?.row?.id}
              // onClick={() => handleClickUpdate(params.row.id)}
              >
                <AiOutlineEdit className="h-5 w-5 text-navy-700" />
              </IconButton>
            </Tooltip> */}
            <Tooltip title="View More Details" arrow placement="top">
              <div className="mr-5">
                <IconButton
                  id={"button-detail-" + params?.row?.id}
                  onClick={() => handleClickDetail(params.row.id)}
                >
                  <AiOutlineFileSearch className="h-5 w-5 text-navy-700" />
                </IconButton>
              </div>
            </Tooltip>
          </>
        );
      },
    },
  ];

  const customDataGridStyles: Partial<GridClasses> = {
    root: "mui-table-custom",
    columnHeader: "text-start text-md",
    row: "",
  };

  const showAddAccountModal = () => {
    setIsOpenAssignFeeGroupModal(true);
  };

  const closeAddAccountModal = () => {
    setIsOpenAssignFeeGroupModal(false);
  };

  const handleClickDetail = (id: any) => {
    const fee = detail?.assigned_agent_feegroups.filter(
      (x: any) => x.id === id
    )[0];
    setFeeToViewDetails(fee);
    showFeeDetailsModal();
  };

  const showFeeDetailsModal = () => {
    setIsOpenFeeDetailsModal(true);
  };

  const closeFeeDetailsModal = () => {
    setFeeToViewDetails(null);
    setIsOpenFeeDetailsModal(false);
  };

  const triggerReloadListForAssignFeeeGroup = () => {
    triggerReload(detail.id);
  };

  return (
    <>
      {isOpenAssignFeeGroupModal && detail && (
        <AgentAssignFeeGroupModal
          setSwalProps={setSwalProps}
          triggerReload={triggerReloadListForAssignFeeeGroup}
          agentDetail={detail}
          isOpen={isOpenAssignFeeGroupModal}
          onClose={closeAddAccountModal}
        />
      )}

      {isOpenFeeDetailsModal && feeToViewDetails && (
        <AgentFeeGroupDetails
          feeDetail={feeToViewDetails}
          isOpen={isOpenFeeDetailsModal}
          onClose={closeFeeDetailsModal}
        />
      )}

      <div className="px-4 py-8">
        <div className="mb-3 flex items-center justify-end">
          <Button
            isDisabled={!detail}
            onClick={() => showAddAccountModal()}
            className="btn btn-action !px-6"
          >
            <FaPlus />
            &nbsp;Assign Fee Group
          </Button>
        </div>
        <Box>
          <DataGrid
            sx={{
              "& .MuiDataGrid-cell": {
                padding: "8px 16px",
              },
              "& .MuiDataGrid-columnHeader": {
                padding: "8px 16px",
              },
              "& .MuiTablePagination-input": {
                marginRight: "-20px",
              },
              "& .MuiTablePagination-displayedRows": {
                display: "none",
              },
            }}
            loading={!detail || isFetchAssignedFeeGroups}
            rows={detail?.assigned_agent_feegroups || []}
            columns={columns}
            getRowId={(row) => row.id}
            pageSizeOptions={[10, 25, 50, 100]}
            rowHeight={48}
            columnHeaderHeight={48}
            disableRowSelectionOnClick
            disableColumnFilter
            disableColumnMenu
            classes={customDataGridStyles}
            hideFooter={true}
            autoHeight
            localeText={{
              noRowsLabel: "No data available",
            }}
          />
        </Box>
      </div>
    </>
  );
};

export default AgentFeesTab;
